"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_present_1 = require("../any/is-present");
function last(array, options) {
    const lastItem = array[array.length - 1];
    if (is_present_1.isPresent(options)) {
        return lastItem || options.fallback;
    }
    return lastItem;
}
exports.last = last;
//# sourceMappingURL=last.js.map